module.exports = __webpack_public_path__ + "img/image-01.c9ea059c.svg";